export default "__VITE_ASSET__CfiqY_RE__"